import { render, staticRenderFns } from "./biddingTable.vue?vue&type=template&id=5f373010&scoped=true&"
import script from "./biddingTable.vue?vue&type=script&lang=js&"
export * from "./biddingTable.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./biddingTable.vue?vue&type=style&index=0&id=5f373010&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5f373010",
  null
  ,true
)

export default component.exports